module.exports = __webpack_public_path__ + "media/images/flags/16/Georgia-b39fe26152a86fea4c280fcf2f4c46b7.png";